import "../styles/howto.scss";
import { useNavigate } from "react-router-dom";

export default function Diff() {
  const navigate = useNavigate();

  return (
    <section className="how__to">
      <h2 className="how__to__headline">We’re creating something different:</h2>
      <section className="how__to__steps">
        <div className="how__to__step step__one">
          <div className="step__number">
            <p>01</p>
          </div>
          <div className="step__description">
            <h3>High-level strategy sessions</h3>
          </div>
        </div>
        <div className="how__to__step">
          <div className="step__number">
            <p>02</p>
          </div>
          <div className="step__description">
            <h3>Speaker-led deep dives with 8 and 9-figure entrepreneurs</h3>
          </div>
        </div>
        <div className="how__to__step">
          <div className="step__number">
            <p>03</p>
          </div>
          <div className="step__description">
            <h3>
              Honest, direct conversations that don’t happen via ZOOM calls or
              WhatsApp messages
            </h3>
          </div>
        </div>
        <div className="how__to__step">
          <div className="step__number">
            <p>04</p>
          </div>
          <div className="step__description">
            <h3>
              Immersive, high-impact experiences that shift how you see yourself
              and what you’re capable of
            </h3>
          </div>
        </div>
      </section>
      <h3 >
        You’ll leave more confident, empowered and wide open to creating
        exceptional new income.
      </h3>
    </section>
  );
}
